import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import initViewportFix from './utils/viewportFix';

// Initialize viewport height fix for mobile devices
initViewportFix();

// Create root element
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the App component - no more Auth0Provider
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);